// extracted by mini-css-extract-plugin
export default {"root":"selector-group-date-view_root__tj6az","placeHolderShimmer":"selector-group-date-view_placeHolderShimmer__VC5bV"};